import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources/resources.ts';

export const DEFAULT_LOCALE = 'de';
export const SUPPORTED_LOCALES = Object.keys(resources);

// Initialize i18next
i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: SUPPORTED_LOCALES,
        fallbackLng: DEFAULT_LOCALE,
        defaultNS: 'common',
        load: 'languageOnly',
        // debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: false,
        },
    });

i18n.on('initialized', () => (document.documentElement.lang = i18n.language));
i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng));

export { i18n };
